export default "__VITE_ASSET__CkoiRGbL__"